import { Wrench, Stethoscope, Settings, GraduationCap, Package } from "lucide-react";

export const CONTACT = {
  phone: "+52 473 118 4344",
  phoneRaw: "524731184344",
  whatsapp: "524731184344",
  email: "javier.hernandez@jansmm.com",
  address: "Avenida Guanajuato #33, Santa Teresa, Guanajuato, México",
  companyFull: "JAN – Servicio y Mantenimiento Minero S.A. de C.V.",
};

// Redes sociales — pega aquí las URLs reales de cada perfil.
// Las que queden vacías ("") no se mostrarán en el footer.
export const SOCIALS = {
  facebook: "",
  instagram: "",
  linkedin: "",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/12201831/pexels-photo-12201831.jpeg",
  about: "https://images.unsplash.com/photo-1659188269611-a360680474f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  // Fotos reales de motores (descargadas del sitio en producción)
  deutz: "/motores/motor-deutz.png",
  cummins: "/motores/motor-cummins.png",
  mercedes: "/motores/motor-mercedes-blanco.jpg",
};

// Logos oficiales de cada marca de motor
export const BRAND_LOGOS = {
  deutz: "/motores/logo-deutz.png",
  cummins: "/motores/logo-cummins.png",
  mercedes: "/motores/logo-mercedes.png",
};

// Sección de asientos: fotos reales y logos de las marcas que se manejan
export const ASIENTOS = {
  logos: [
    { src: "/asientos/logo-ultra-white.png", alt: "Ultra" },
    { src: "/asientos/logo-grammer-white.png", alt: "Grammer" },
  ],
  fotos: [
    { src: "/asientos/asiento-grammer-1.jpg", alt: "Asiento premium con suspensión y cabezal" },
    { src: "/asientos/asiento-grammer-2.jpg", alt: "Asiento con suspensión y descansabrazos" },
    { src: "/asientos/asiento-grammer-3.jpg", alt: "Asiento compacto para montacargas" },
  ],
  aplicaciones: ["Equipos de minería", "Equipos de construcción", "Camiones"],
};

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1680463990599-9d318aaecf71?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Excavadora en mina a cielo abierto" },
  { url: "https://images.unsplash.com/photo-1586161148512-64a1b3dac527?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Camión minero en túnel subterráneo" },
  { url: "https://images.pexels.com/photos/32594486/pexels-photo-32594486.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Ingeniero en túnel de mina" },
  { url: "https://images.unsplash.com/photo-1709489662983-3674d790b224?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Camión de carga en operación" },
  { url: "https://images.pexels.com/photos/6720532/pexels-photo-6720532.jpeg?auto=compress&cs=tinysrgb&w=900", alt: "Reparación de motor de camión" },
  { url: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", alt: "Mecánico especializado en motores" },
];

export const VALUES = [
  { title: "Integridad", desc: "Cumplimos con nuestra palabra y compromisos. Coherencia entre lo que decimos y hacemos." },
  { title: "Calidad", desc: "Todo el equipo está comprometido con la calidad de los servicios que ofrecemos." },
  { title: "Actitud", desc: "Trabajamos de forma coordinada, complementaria y comprometida." },
  { title: "Responsabilidad", desc: "Somos responsables de nuestros actos y decisiones." },
  { title: "Excelencia", desc: "Somos competentes en nuestro trabajo y nos superamos día a día." },
];

export const CAPABILITIES = [
  { icon: Settings, label: "Reparación general de motor" },
  { icon: Stethoscope, label: "Diagnóstico de fallas" },
  { icon: Wrench, label: "Servicios generales" },
  { icon: Package, label: "Venta de refacciones" },
  { icon: GraduationCap, label: "Capacitación" },
];

export const SERVICES = [
  {
    id: "deutz",
    brand: "Motores DEUTZ",
    tag: "+10 años de experiencia",
    desc: "Técnico especializado y capacitado por DEUTZ. Servicio para toda la línea de motores.",
    image: IMAGES.deutz,
    logo: BRAND_LOGOS.deutz,
    points: ["Reparación general de motor", "Diagnóstico de falla", "Servicios generales", "Venta de refacciones", "Capacitación"],
  },
  {
    id: "cummins",
    brand: "Motores CUMMINS",
    tag: "Certificado CUMMINS",
    desc: "Técnico especializado y capacitado por CUMMINS para la línea completa de motores industriales.",
    image: IMAGES.cummins,
    logo: BRAND_LOGOS.cummins,
    points: ["Venta de refacciones", "Reparación general de motor", "Diagnóstico de falla", "Servicios", "Capacitación"],
  },
  {
    id: "mercedes",
    brand: "Motores MERCEDES BENZ",
    tag: "Minería subterránea",
    desc: "Técnico especializado en motores Mercedes Benz para aplicación en equipos de minería subterránea.",
    image: IMAGES.mercedes,
    logo: BRAND_LOGOS.mercedes,
    points: ["Reparación general de motor", "Diagnóstico de falla", "Servicios", "Capacitación", "Venta de refacciones"],
  },
];

export const CUMMINS_MODELS = [
  { modelo: "QSB3.3", hp: "99 HP" },
  { modelo: "QSB4.5", hp: "130 HP" },
  { modelo: "QSB4.5", hp: "160 HP" },
  { modelo: "QSB6.7", hp: "193 HP" },
  { modelo: "QSB6.7", hp: "220 HP" },
  { modelo: "QSL9", hp: "280 HP" },
  { modelo: "QSL9", hp: "300 HP" },
  { modelo: "QSM11", hp: "335 HP" },
  { modelo: "QSM11", hp: "400 HP" },
  { modelo: "QSX15", hp: "390 HP" },
  { modelo: "QSX15", hp: "450 HP" },
  { modelo: "QSX15", hp: "520 HP" },
];
